import React from 'react';
// Module imports.
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CreditScore from '@mui/icons-material/CreditScore';
import { Tooltip as ReactTooltip } from "react-tooltip";
import Styles from '../account.module.scss';
// Components Import.
import { Card, Message, Table, useAPI, useTranslation } from 'components/lib';

export function BillingInvoices(props) {

    const { t } = useTranslation();
    const invoices = useAPI('/api/account/invoice');

    const invoiceSymbol = (invoiceStatus, invoiceLink) => {
        const commonProps = {
            'aria-label': 'invoice',
            onClick: () => {
                const newTab = window.open(invoiceLink, '_blank');
                newTab.focus();
            },
        };

        switch (invoiceStatus) {
            case 'open':
                return (

                    <>
                        <span {...commonProps} data-tooltip-id="my-tooltip-1" data-tooltip-hidden={!props.tooltip}>
                            <CreditCardIcon fontSize='large' sx={{ color: '#FF1616', cursor: 'pointer' }} />
                        </span>
                        <ReactTooltip
                            id="my-tooltip-1"
                            place="bottom"
                            content={t('account.billing.invoice.tooltip')}
                            isOpen={true}
                        />
                    </>

                );
            case 'paid':
                return (
                    <span {...commonProps}>
                        <CreditScore fontSize='large' sx={{ color: '#008037', cursor: 'pointer' }} />
                    </span>
                );
            case 'draft':
                return (
                    <span {...commonProps} disabled onClick={() => { }}>
                        <CreditScore fontSize='large' sx={{ pointerEvents: 'none', opacity: 0.5 }} />
                    </span>
                );
            default:
                return (
                    <span {...commonProps}>
                        <CreditScore fontSize='large' sx={{ cursor: 'pointer' }} />
                    </span>
                );
        }
    };


    return (
        <>
            <Card className={Styles.cardContainer} loading={invoices?.loading}>
                {invoices?.data ? (
                    <Table
                        loading={invoices.loading}
                        badge={{
                            col: 'status', color: 'red', condition: [

                                { value: 'paid', color: 'green' },

                            ]
                        }}
                        data={invoices?.data?.map(x => {
                            //x.invoice_url will give the invoice url generated in the pdf
                            return {
                                invoice_number: x.number ? x.number : t('account.billing.invoice.number'),
                                date: x.date,
                                status: x.status,
                                total: x.total,
                                invoice: invoiceSymbol(x.status, x.invoice_url),
                                actions: { download: x.invoice_pdf }
                            }
                        })}
                        translation='account.billing.invoice'
                    />
                ) : (
                    <Message
                        title="No invoices available yet"
                        text="Once you make a payment or subscribe to a paid plan, your invoices will appear here."
                        type="info"
                    />
                )}
            </Card>
        </>
    );
}